export default __webpack_public_path__ + "static/media/FillableRequestForProjectProposalTemplate.6ed2a5e0.pdf";